import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useListFlowNodesByBranches = () => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading,
    isSuccess,
    isError,
    data,
    mutate,
    reset,
  } = useMutation(
    ['list-flow-nodes-by-branches', orgId],
    async ({
      cleanRoomID,
      cleanRoomFlowID,
      branches,
      flowVersion,
      parentFlowRunID = '',
      excludeNodesWithoutTags,
      ignoreParentChildRule,
      includeMismatchingTaggedNodes,
      startLevelID,
      pauseLevelID,
    }) => {
      const payload = {
        organizationID: orgId,
        cleanRoomID,
        flowVersion: flowVersion || -1,
        branches,
        parentFlowRunID,
        cleanRoomFlowID,
      };

      if (excludeNodesWithoutTags) {
        payload.excludeNodesWithoutTags = excludeNodesWithoutTags;
      }

      if (ignoreParentChildRule) {
        payload.ignoreParentChildRule = ignoreParentChildRule;
      }

      if (includeMismatchingTaggedNodes) {
        payload.includeMismatchingTaggedNodes = includeMismatchingTaggedNodes;
      }

      if (startLevelID) {
        payload.startLevelID = startLevelID;
      }

      if (pauseLevelID) {
        payload.pauseLevelID = pauseLevelID;
      }

      return axiosInstance.post(flow(orgId).includedNodes(cleanRoomID, cleanRoomFlowID), payload);
    },
    {
      onError: (error) => dispatch(showAlert({
        message: error.response?.data?.message || 'Failed to fetch nodes by branches.',
        type: 'error',
      })),
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    mutate,
    reset,
  };
};
